module.exports = __webpack_public_path__ + "img/4@s.80a58aed.jpg";